module.exports = __webpack_public_path__ + "static/media/Stock.751f64e3.svg";